// extracted by mini-css-extract-plugin
export var equalColumn = "_dr-0";